import { injectable } from '~/container'
import { GuestBooking } from './schema'
import { ReviewFormData } from './types'

@injectable()
export abstract class AddReviewRepository {
  abstract create(
    campsiteSlug: string,
    reviewFormData: ReviewFormData,
    token: string,
    langCode: string,
  ): Promise<{ id: string }>
}

@injectable()
export abstract class GuestBookingsRepository {
  abstract getByToken(token: string, langCode: string): Promise<GuestBooking>
}
